// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ItemsPublishingGet } from '../../../../types/server/modules/itemsPublishing/get';

export type * from '../../../../types/server/modules/itemsPublishing/get';

export const createGet = ( requests: Requests ): ItemsPublishingGet => ({
  mercadolibre_discover_category_by_title: ( params,headers ) => {
      return requests.get( `/items-publishing/mercadolibre-discover-category-by-title`, params, headers );
    },
  mercadolibre_search_products_catalog: ( params,headers ) => {
      return requests.get( `/items-publishing/mercadolibre-search-products-catalog`, params, headers );
    },
  size_guides_channel_charts_import: ( params,headers ) => {
      return requests.get( `/items-publishing/size-guides-channel-charts`, params, headers );
    },
  size_guides_active_domains: ( params,headers ) => {
      return requests.get( `/items-publishing/size-guides-active-domains`, params, headers );
    },
  get_channels_publication_form_type: ( params,headers ) => {
      return requests.get( `/items-publishing/channels-publication-form-type`, params, headers );
    },
  get_channels_publication_default_values_type: ( params,headers ) => {
      return requests.get( `/items-publishing/channels-publication-default-values-type`, params, headers );
    }
});
